import RecoverStep from "../recover_step";
import axios from "../../../../axios-instance";

const TEMPLATE = 'rb-set-device';

export default class RbSetDevice extends RecoverStep {

    constructor() {
        super(TEMPLATE);
    }

    open(data, el, fr, previousStep) {
        const clientId = data.clientId;
        const applianceId = data.applianceId;
        data.render = { readyToRender : false };
        data.recovery.dataTable = {
            columns: null,
            data: null
        }
        this.loadTableColumns().then(response => {
            const tableColumns = response.data;
            data.recovery.dataTable.columns = tableColumns;

            axios.get(`/client/load_rb_devices_table_data/${clientId}/${applianceId ? applianceId : ""}`).then(
                response => {
                    data.recovery.dataTable.data = response.data;
                    const tableData = this.prepareTableData(response.data, data);
                    data.render.readyToRender = true;
                    fr.render('rbSetDevice');
                    const devicesTable = document.getElementById("recovery_devices_table")
                    devicesTable.columns = tableColumns
                    devicesTable.data = tableData
                    devicesTable.addEventListener('rowSelected', (event) => {
                        const machineId = event.detail?.values()?.next()?.value
                        if (machineId) {
                            data.recovery.machineId = machineId;
                            data.recovery.openRpCalendarAfterReloadData = true;
                            const machineItem = data.recovery.dataTable.data.find(item => item.id === machineId);
                            data.recovery.machineName = machineItem.psName;
                            if (machineItem.isPasswordProtected) {
                                fr.goTo('setPsPassword');
                            } else {
                                fr.goTo('selectRestorePoint');
                            }
                        }
                    })
                }
            ).catch(() => {
                fr.defaultAJAXErrorHandler()
            });
        }).catch(() => {
            fr.defaultAJAXErrorHandler()
        });
    }

    loadTableColumns() {
        return axios.get('/device/load_rb_devices_table_columns')
    }

    prepareTableData(tableRows, data) {
        let tableData = [];
        tableRows.forEach(row => {
            let rowData = [];
            let id = null;
            const disabledMacOsX = row.systemOsType === 'MAC_OS_X' && data.recovery.type === 'virtual-disk';
            const disabledNas = row.systemOsType === 'NAS' && data.recovery.type === 'virtual-disk';
            const isDisabled = disabledMacOsX || disabledNas;
            if (row.ftpsAllowed && !isDisabled) {
                id = row.id;
            }
            rowData.push(id);

            let icon = null;
            if (row.ftpsAllowed && row.isPasswordProtected) {
                icon = '<span class="icon-key text-dark"></span>';
            } else if (!row.ftpsAllowed || isDisabled) {
                icon = isDisabled
                    ? disabledMacOsX
                        ? `<axs-tooltip alignment="left">${_flow_recovery_select_device_mac_os_is_ineligible_for_recovery}</axs-tooltip> `
                        : `<axs-tooltip alignment="left">${_flow_recovery_select_device_nas_is_ineligible_for_recovery}</axs-tooltip> `
                    : `<axs-tooltip alignment="left">${_flow_recovery_select_device_has_no_valid_ps}</axs-tooltip>`;
            }
            rowData.push(icon);
            rowData.push(`<span title="${row.psName}">${row.psName}</span>`);
            rowData.push(`<span title="${row.applianceName}">${row.applianceName}</span>`);
            rowData.push(row.systemType);
            rowData.push(row.latestCloudRp);
            tableData.push(rowData);
        });
        return tableData;
    }

    transitionBack(data, el, fr) {
        if (data.recovery.type === "file_or_folder") {
            fr.goTo('typeRB');
        }
        else if (data.recovery.type === "virtual-disk") {
            fr.goTo('exportVirtualDisk');
        }
    }
}
